module.exports = __webpack_public_path__ + "assets/img/copyright.390f5c41.png";